import { createFileRoute } from "@tanstack/react-router";

import Terms from "@/components/pages/Terms";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/terms-and-conditions")({
  component: () => (
    <BasicLayout>
      <Terms />
    </BasicLayout>
  ),
});
